import classNames from 'classnames';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

interface TwoColumnProps {
  /** List of columns. */
  children: React.ReactElement[];
  /** CSS class name */
  className?: string;
  /** Props for the elements in the left columns. */
  bsColPropsLeft?: any;
  /** Props for the elements in the right columns. */
  bsColPropsRight?: any;
}

const TwoColumns = ({
  children,
  className,
  bsColPropsLeft,
  bsColPropsRight,
}: TwoColumnProps) => {
  const c = children.map((node, index) => {
    if (index % 2 === 0) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <Col {...bsColPropsLeft} key={`index_${index}`}>
          {node}
        </Col>
      );
    }
    return (
      // eslint-disable-next-line react/no-array-index-key
      <Col {...bsColPropsRight} key={`index_${index}`}>
        {node}
      </Col>
    );
  });

  return (
    <div className={classNames(className, 'ce ce-two-columns')}>
      <Row>{c}</Row>
    </div>
  );
};

TwoColumns.defaultProps = {
  bsColPropsLeft: { md: 6 },
  bsColPropsRight: { md: 6 },
  className: null,
};

export default TwoColumns;
